module.exports = __webpack_public_path__ + "static/media/bg2.cfb26208.jpg";